const shippingThreshold = 200;
const currency = { code: "USD", symbol: "$" };

const siteConfig = {
  brandName: "Bantumtrail",
  wordmark: "Bantumtrail",
  logo: {
    text: "Bantumtrail",
    alt: "Bantumtrail home",
  },
  tagline: "For the Adventure",
  description:
    "Independent outdoor clothing made for everyday movement, weekend escapes, and life outside.",
  announcement: {
    text: `Free domestic shipping on orders over ${currency.symbol}${shippingThreshold}`,
    to: "/shop",
  },
  fieldStrip: ["New York", "Tokyo", "Topanga Canyon", "For the Adventure"],
  contact: {
    email: "mark@bantumtrail.xyz",
    phone: "+1 212 555 0148",
    address: "New York, NY, United States",
    location: "New York, USA",
  },
  shippingThreshold,
  shippingRates: {
    standard: 18,
    express: 32,
  },
  returnWindowDays: 14,
  currency,
  primaryNavigation: [
    { label: "SHOP NOW", to: "/shop" },
    { label: "TOPS", to: "/shop?category=Tops" },
    { label: "BOTTOMS", to: "/shop?category=Bottoms" },
    { label: "TEES", to: "/shop?category=Tees" },
    { label: "SWEATS", to: "/shop?category=Sweats" },
    { label: "HATS", to: "/shop?category=Hats" },
    { label: "BAGS", to: "/shop?category=Bags" },
    { label: "ABOUT", to: "/about" },
  ],
  footerNavigation: [
    {
      title: "Shop",
      links: [
        { label: "Shop all", to: "/shop" },
        { label: "Tops", to: "/shop?category=Tops" },
        { label: "Bottoms", to: "/shop?category=Bottoms" },
        { label: "Hats", to: "/shop?category=Hats" },
        { label: "Bags", to: "/shop?category=Bags" },
      ],
    },
    {
      title: "Help",
      links: [
        { label: "Shipping", to: "/shipping" },
        { label: "Returns", to: "/returns" },
        { label: "Contact", to: "/contact" },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "About", to: "/about" },
        { label: "Privacy", to: "/privacy" },
        { label: "Terms", to: "/terms" },
      ],
    },
  ],
  newsletter: {
    eyebrow: "Newsletter",
    title: "Get outside with us",
    description:
      "Subscribe for first looks at new collections, field notes, and 10% off your first order.",
  },
  socialLinks: [
    {
      label: "Instagram",
      href: "https://www.instagram.com/",
    },
  ],
  storageKeys: {
    cart: "cartItems",
    wishlist: "wishlistItems",
    newsletter: "newsletterSubscribers",
  },
};

export default siteConfig;
